<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import MarcaRequest from 'Modules/contacard/produto/marca/MarcaRequest';

export default {
  name: 'MarcaCrudList',
  extends: CrudListVue,
  data: () => ({
    requestClass: MarcaRequest,
    editRoute: 'marca.edit',
    hideDelete: true,
    headers: [
      {
        text: 'Marca',
        value: 'nomMarca',
      },
      {
        text: 'Código',
        value: 'id',
      },
      {
        text: 'Última alteração',
        value: 'updatedDate',
        component: 'DataTableDateColumn',
      },
    ],
  }),
};
</script>
